import * as React from "react";
export const useChatMessage = (entry, messageFormatter) => {
    var _a, _b;
    const formattedMessage = React.useMemo(() => {
        return messageFormatter ? messageFormatter(entry.message) : entry.message;
    }, [entry.message, messageFormatter]);
    const hasBeenEdited = !!entry.editTimestamp;
    const time = new Date(entry.timestamp);
    const locale = typeof navigator !== "undefined" ? navigator.language : "en-US";
    const name = ((_a = entry.from) === null || _a === void 0 ? void 0 : _a.name) && entry.from.name !== ""
        ? entry.from.name
        : (_b = entry.from) === null || _b === void 0 ? void 0 : _b.identity;
    return { message: formattedMessage, hasBeenEdited, time, locale, name };
};
